import React from "react";
import "./StepFive.css";
import {
  Button,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  styled,
} from "@mui/material";
import { stepFiveData } from "../stepsData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";

const StepFive = () => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  // Styling Table Cell
  const tableHeadingsStyle = {
    xs: "14px",
    lg: "16px",
  };
  const tableContentStyle = {
    md: "14px",
    lg: "16px",
  };

  return (
    <>
      <div className="step-five mt-2">
        <Typography
          sx={{
            fontSize: "23.8532px",
            color: "#1F1F1F",
            fontFamily: "'Archivo', sans-serif",
          }}
          className="archivo fw-bold"
        >
          {stepFiveData[0].stepFiveHeading}
        </Typography>
        <div>
          <Typography
            sx={{
              fontSize: 18,
              lineHeight: "24px",
              color: "#59266D",
              fontWeight: 600,
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo mt-2"
          >
            {stepFiveData[0].subHeading}
          </Typography>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              fontFamily: "'Archivo', sans-serif",
            }}
            className="archivo mt-3"
          >
            {stepFiveData[0].comparisonHead}
          </Typography>
        </div>
        <div className="mt-3">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    // backgroundColor: "#e6c1fd",
                    // backgroundColor: "#E2E3E5",
                    backgroundColor: "#e7e4f9",
                    alignContent: "start",
                  }}
                >
                  {stepFiveData[0].comparingTable.headings &&
                    stepFiveData[0].comparingTable.headings.map(
                      (item, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            fontSize: tableHeadingsStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #c7c7c7",
                            verticalAlign: "top",
                          }}
                          className="archivo"
                        >
                          {item.head}
                        </TableCell>
                      )
                    )}
                </TableRow>
              </TableHead>
              <TableBody>
                {stepFiveData[0].comparingTable.row &&
                  stepFiveData[0].comparingTable.row.map((item, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                          borderRight: "1px solid #E0E0E0",
                          verticalAlign: "top",
                        }}
                      >
                        {item.bank}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                          borderRight: "1px solid #E0E0E0",
                          verticalAlign: "top",
                        }}
                      >
                        {item.interest}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                          borderRight: "1px solid #E0E0E0",
                          verticalAlign: "top",
                        }}
                      >
                        {item.processingFee}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                          borderRight: "1px solid #E0E0E0",
                          verticalAlign: "top",
                        }}
                      >
                        {item.tenure}
                      </StyledTableCell>
                      <StyledTableCell
                        sx={{
                          fontSize: tableContentStyle,
                          fontFamily: "'Archivo', sans-serif",
                          color: "#1F1F1F",
                          borderRight: "1px solid #E0E0E0",
                          verticalAlign: "top",
                        }}
                      >
                        {item.spcFeature}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div className="d-flex flex-column flex-md-row gap-2 mt-3">
          <Button
            sx={{
              backgroundColor: "#553285",
              color: "white",
              borderRadius: 2,
              padding: "5px 20px",
              fontFamily: "Archivo",
              fontWeight: 500,
              fontSize: 14,
              textTransform: "none",
            }}
            onClick={() => {
              // window.location.href =
              //   "https://minemi.ai/personal-loan/check-eligibility";
            }}
          >
            Apply for a Wedding Loan Now
          </Button>
        </div>
      </div>
      <Button
        sx={{
          textTransform: "none",
          margin: "0px",
          fontSize: 16,
          fontFamily: "'Archivo', sans-serif",
        }}
        onClick={() => {
          window.scroll(0, 0);
        }}
        className="d-flex algin-items-center archivo mt-2"
      >
        <FontAwesomeIcon icon={faArrowUp} /> &nbsp; Back To Top
      </Button>
    </>
  );
};

export default StepFive;
